import { Quiz, QuizMeta } from "@garther/interfaces";

export const getQuestionMeta = (question: Quiz, language: "en" | "vi" = "en"): QuizMeta => {
  const meta = question.meta[language] || question.meta.en;
  return meta!;
};

export const getQuestionText = (question: Quiz, language: "en" | "vi" = "en"): string => {
  const meta = getQuestionMeta(question, language);
  return meta?.question || "Question not available";
};
